/*
 * @Descripttion:
 * @Date: 2025-04-09 10:16:04
 */
import { Ref } from 'vue';
import {
  createDialog,
  BaseButton,
  useCreateModal,
  XrkMessage,
  XrkTableRef
} from 'xrk-components';
import { batchAudit, taskRecordPassIds } from '../data-source/apis';
import NoPass from '../components/no-pass.vue';
import DigitalZoneDetail from '../components/digitalzone-detail.vue';
import TaskDetail from '../components/task-detail.vue';

export const useTaskAudit: ({
  auditStatus,
  queryParams,
  auditOver,
  projectId,
  isBatch
}: {
  queryParams: {
    sceneType: number;
    taskRecordId: number[];
  };
  auditOver: () => void;
  auditStatus: 2 | 3; //2审核通过3审核未通过
  projectId: number;
  isBatch?: boolean; //是否批量操作
}) => void = async ({
  queryParams,
  auditOver,
  auditStatus,
  projectId,
  isBatch = false
}) => {
  if (isBatch) {
    if (queryParams.taskRecordId.length === 0) {
      XrkMessage.error('请至少选择一条数据');
      return;
    }
    const { data } = await taskRecordPassIds({
      sceneType: queryParams.sceneType,
      projectId: projectId,
      taskRecordId: queryParams.taskRecordId
    });
    const personUplevel = {
      taskSum: data.taskSum,
      personNum: data.personNum,
      personNames: data.personNames,
      checkPersonNum: data.checkPersonNum,
      taskRecordId: data.taskRecordId
    };
    // 有人员升级个体则将过滤后的id传给审核
    if (personUplevel.personNum !== 0)
      queryParams.taskRecordId = personUplevel.taskRecordId;

    // 批量审核
    createDialog({
      width: personUplevel.personNum === 0 ? 350 : 500,
      title: '提示',
      showClose: true,
      closeOnPressEscape: true,

      contentRender() {
        return (
          <>
            <div style="padding: 20px">
              {personUplevel.personNum === 0 && (
                <p>
                  是否确认{auditStatus === 3 ? '不' : ''}通过
                  <span style="color:#027cfa">
                    {queryParams.taskRecordId.length}
                  </span>
                  条任务记录，请谨慎操作
                </p>
              )}
              {personUplevel.personNum !== 0 && (
                <p style="line-height: 20px;">
                  <p>
                    已选中
                    <span style="color:#027cfa">{personUplevel.taskSum}</span>
                    条任务
                  </p>
                  <p>
                    其中
                    <span style="color:#027cfa">{personUplevel.personNum}</span>
                    人 （含<>{personUplevel.personNames.join('、')}</>
                    ）因已升级为个体身份，其相关任务无法通过审核。
                  </p>
                  <p>
                    点击【确定】后，将仅通过剩余
                    <span style="color:#027cfa">
                      {personUplevel.checkPersonNum}
                    </span>
                    条任务，是否确认该操作？
                  </p>
                </p>
              )}
            </div>
          </>
        );
      },
      footerRender(done) {
        return (
          <div>
            <BaseButton
              type="default"
              onClick={() => {
                done();
              }}
            >
              取消
            </BaseButton>
            <BaseButton
              type="primary"
              click={async () => {
                if (auditStatus === 3) {
                  useCreateModal(NoPass, {
                    projectId: projectId,
                    async onConfirm({ remarkType, remarks }) {
                      await batchAudit({
                        ...queryParams,
                        auditStatus,
                        remarkType,
                        remarks,
                        projectId
                      });
                      auditOver();
                      done();
                    }
                  });
                } else {
                  await batchAudit({
                    ...queryParams,
                    auditStatus,
                    projectId
                  });
                  auditOver();
                  done();
                }
              }}
            >
              确定
            </BaseButton>
          </div>
        );
      }
    });

    return;
  }

  //单条审核通过
  if (auditStatus === 2) {
    createDialog({
      width: 350,
      title: '提示',
      showClose: true,
      closeOnPressEscape: true,
      content: `是否确认审核通过？`,
      footerRender(done) {
        return (
          <div>
            <BaseButton
              type="default"
              onClick={() => {
                done();
              }}
            >
              取消
            </BaseButton>
            <BaseButton
              type="primary"
              onClick={async () => {
                await batchAudit({ ...queryParams, auditStatus, projectId });
                auditOver();
                done();
              }}
            >
              确定
            </BaseButton>
          </div>
        );
      }
    });
    //单条审核不通过
  } else if (auditStatus === 3) {
    useCreateModal(NoPass, {
      projectId: projectId,
      async onConfirm({ remarkType, remarks }) {
        await batchAudit({
          ...queryParams,
          auditStatus,
          remarkType,
          remarks,
          projectId
        });
        auditOver();
      }
    });
  }
};

/**
 * @description: 查看任务详情
 * !!! 注意，非项目详情内的路由，需要设置项目详情缓存，可以参考 procurement-mgmt-audit 文件里的逻辑
 **  id 任务 id
 **  buttonOnOff 审核按钮是否可操作
 **  dataState 数据状态0未结算1结算中2已结算
 **  projectType 项目场景类型
 **  projectId 项目 id
 **  canAudit 任务详情右侧弹框 操作按钮是否显示
 **  xrkTableRef
 **  isShowMapHandleBtn 是否显示地图操作按钮
 */
export const useOpenTaskDetail = async (params: {
  id: number;
  dataState: number;
  projectType: number;
  projectId: number;
  canAudit: number | boolean;
  xrkTableRef?: Ref<XrkTableRef>;
  isShowMapHandleBtn?: boolean;
}) => {
  const {
    id,
    dataState,
    projectType,
    projectId,
    canAudit,
    xrkTableRef,
    isShowMapHandleBtn
  } = params;

  //数字专区
  if (projectType === 6) {
    createDialog({
      width: 1200,
      title: '任务详情',
      showClose: true,
      closeOnPressEscape: true,
      contentRender: () => {
        return (
          <DigitalZoneDetail
            projectType={projectType}
            projectId={projectId}
            id={id}
            dataState={dataState}
          />
        );
      }
    });
    return;
  }
  const taskDetailModal = useCreateModal(TaskDetail, {
    id: id,
    dataState: dataState,
    projectId: projectId,
    detailId: projectId,
    projectType: projectType,
    canAudit: canAudit,
    isShowMapHandleBtn,
    searchVal: xrkTableRef?.value?.getSearchValue?.() || undefined,
    onAuditOver(nextTaskId) {
      XrkMessage.success('操作成功');
      xrkTableRef?.value?.initCurrentList?.();
      xrkTableRef?.value?.clearSelectionRows();
      if (nextTaskId) {
        taskDetailModal.remove();
        useOpenTaskDetail({ ...params, id: nextTaskId });
      } else {
        taskDetailModal.remove();
      }
    },
    onRefresh() {
      taskDetailModal.remove();
      useOpenTaskDetail(params);
    }
  });
};
